import React from 'react'
import { Redirect, useParams, useLocation, useQueryParams } from '@fs/zion-router'
import { useContainerWidth } from '@fs/zion-ui'
import { useLastViewedPersonView } from '@fs/zion-tree-groups'
import { vitalTypes } from '../person-page/PersonPage'
import { RedirectToStartingPid } from './RedirectToStartingPid'

export default function RedirectToDetails(): JSX.Element | null {
  const { pid, subPage } = useParams()
  const atWidth = useContainerWidth()
  const { search } = useLocation()
  const { loading, view } = useLastViewedPersonView()
  const { query } = useQueryParams()
  // openDetail is for backwards compatibility with old v8 links
  const { conclusionQuery = query.openDetail } = query

  return <RedirectToDetailsContent {...{ atWidth, search, subPage, pid, loading, conclusionQuery }} view={view} />
}

type Props = {
  atWidth: ReturnType<typeof useContainerWidth>
  search: string
  subPage?: string
  view?: string | null
  pid?: string
  loading?: boolean
  conclusionQuery?: string
}
// exported for testing purposes
export function RedirectToDetailsContent({
  atWidth,
  search,
  subPage,
  view,
  pid,
  loading,
  conclusionQuery = '',
}: Props): JSX.Element | null {
  if (!subPage && loading) return null
  const defaultView = atWidth({ lg: 'details', default: 'vitals' })
  const isAutoOpenConclusion = search.includes('conclusion')
  const isAutoOpenCoupleRelationship = search.includes('coupleRelationshipId')

  let searchOverrideView: 'details' | 'vitals' | 'non-vitals' | 'family' | undefined

  if (defaultView === 'vitals') {
    if (isAutoOpenConclusion) {
      if (vitalTypes.includes(conclusionQuery)) {
        searchOverrideView = defaultView
      } else {
        searchOverrideView = 'non-vitals'
      }
    }
    if (isAutoOpenCoupleRelationship) {
      searchOverrideView = 'family'
    }
  } else if (isAutoOpenConclusion || isAutoOpenCoupleRelationship) {
    searchOverrideView = defaultView
  }

  const targetSubPage = searchOverrideView ?? subPage ?? view ?? defaultView
  return pid ? <Redirect to={`/${targetSubPage}/${pid}${search}`} /> : <RedirectToStartingPid subPage={targetSubPage} />
}
